module.exports = __webpack_public_path__ + "img/ic_team_youtube.e882167a.svg";